<template>
  <div>
    <div v-if="loading" class="uk-flex uk-flex-center spinner-top-padding">
      <spinner></spinner>
    </div>
    <div v-else>
      <div v-if="!resourceItems" class="container">
        <div class="uk-flex uk-flex-center">
          <img :src="icon">
        </div>
        <span class="uk-flex uk-flex-center heading-style">{{$t('sharedResources.nothingHereYet')}}</span>
        <span class="uk-flex uk-flex-center message-style">{{$t('sharedResources.helpOtherTeachers')}}</span>
        <div class="uk-flex uk-flex-center">
          <button v-if="isUploadEnabled" class="share-button uk-button add-pointer"
                  @mouseover="resolveHover(true)"
                  @mouseleave="resolveHover(false)"
                  @click="shareResource">
            <img v-if="!hover" class="share-icon" :src="whiteShareIcon">
            <img v-else class="share-icon" :src="blueShareIcon">
            <span class="uk-text-capitalize share-text" >{{$t('general.shareAResource')}}</span>
          </button>
        </div>
      </div>
      <div v-else>
        <div v-for="item in resourceItems">
          <result-item :lastPulledDate="lastPulledDate" :item="item" :key="item.contentId"></result-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import iconUtil from '../../../../utils/icon-util'
  import * as misc from '../../../../enums/misc'
  import router from '../../../../router/index'
  import resultItem from '../../../search/search-results/desktop/search-result-item'
  import spinner from '../../../ui-components/spinner/spinner'
  import {mapGetters} from 'vuex'
  import * as _ from 'lodash'
  import { UPLOAD_CONTENT_SMEX } from '@/plugins/feature/feature-list'

  export default {
    name: 'shared-resources',
    components: {
      resultItem,
      spinner
    },
    props: ['resources', 'lastPulledDate', 'loading'],
    data() {
      return {
        icon: iconUtil.resolve(misc.NO_SHARED_RESOURCES),
        whiteShareIcon: iconUtil.resolve(misc.SHARE_ICON_WHITE),
        blueShareIcon: iconUtil.resolve(misc.SHARE_ICON_BLUE),
        hover: false
      }
    },
    methods: {
      resolveHover(hover) {
        this.hover = hover
      },
      shareResource() {
        router.push('/share-resource')
      }
    },
    computed: {
      ...mapGetters(['getApprovedResourcesPage']),
      resourceItems() {
        if (this.resources.length) {
          let start = 0
          let end = misc.PAGING_SIZE
          if (this.getApprovedResourcesPage > 1) {
            end = misc.PAGING_SIZE * this.getApprovedResourcesPage
            start = (end - misc.PAGING_SIZE) - 1
          }
          return _.slice(this.resources, start, end)
        }
      },
      isUploadEnabled() {
        return this.$feature(UPLOAD_CONTENT_SMEX.name).enabled
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '../../../../../src/styles/colours';

  .container {
    margin-top: 100px;
  }

  .heading-style {
    font-size: 30px;
    font-weight: bold;
    color: $content-text;
    margin-top: 23px;
    text-align: center;
  }

  .share-icon {
    padding-left: 5px;
    padding-right: 8px;
    padding-bottom: 3px;
  }

  .message-style {
    font-size: 28px;
    color: $content-text;
    margin-top: 25px;
    text-align: center;
  }

  .share-button {
    margin-top: 31px;
    min-width: 175px;
    min-height: 32px;
    border-radius: 2px;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.24);
    border: solid 1.8px $light-blue;
    background-color: $light-blue;
    color: white;
    font-size: 14px;
    font-weight: bold;
    line-height: 30px;
    padding: 0;
    &:hover {
      border-radius: 2px;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 1.8px white;
      background-color: white;
      color: $light-blue;
    }
  }

  .share-text {
    padding-right: 5px;
  }

  .spinner-top-padding {
    padding-top: 400px;
  }
</style>
